document.addEventListener("DOMContentLoaded", function() {
  var announcements = document.querySelectorAll('.announcement-bar');
  var currentIndex = 0;

  function rotateAnnouncements() {
    announcements[currentIndex].style.opacity = '0';
    announcements[currentIndex].style.pointerEvents = 'none';

    currentIndex = (currentIndex + 1) % announcements.length;

    announcements[currentIndex].style.opacity = '1';
    announcements[currentIndex].style.pointerEvents = 'auto';
  }

  setInterval(rotateAnnouncements, 5000);
});
